import React from "react";
import { Expression, Operand } from "@merrie/nmbrs-api";
import { ExpressionEntryComponent } from "../expression-entry/expression-entry.component";
import { OperandComponent } from "..";

export interface IExpressionProperties {
  expression: Expression;
  operand?: Operand;
  isEvaluated?: boolean;
}

export const ExpressionComponent: React.FC<IExpressionProperties> = ({
  expression,
  operand,
  isEvaluated,
}) => (
  <div className={"expression"}>
    {expression.entries.map((entry, index) => (
      <ExpressionEntryComponent entry={entry} key={index} />
    ))}
    {operand && <OperandComponent operand={operand} total={false} />}
    {isEvaluated && "="}
  </div>
);
